module.exports = "/_next/static/images/PersonalizeCampaigns-d39c7c5a647dfe29212717a4d1ee9282.webp";